import "./styles.scss";
import { RedExclamationCircle } from "../../assets/svgs";

const ErrorImage = () => {
  return (
      <div className="error-image-wrapper">
        <img src={RedExclamationCircle} alt="error" className="error-image" />
      </div>
  );
};

export default ErrorImage;
